export const PREVIEW_SHEET_EN = {
  previewSheetTitle: 'Title',
  previewSheetDescription: 'Preview'
} as const

export const PREVIEW_SHEET_DE = {
  previewSheetTitle: 'Titel',
  previewSheetDescription: 'Vorschau'
} as const
